import React from 'react';
import WazuhPartnersPortal from './img/WazuhPartnersPortal.svg';
import MenuProfile from './Menu';
import MobileMenu from './MobileMenu';
import { Link } from 'react-router-dom';
import WazuhPartnersPortalLogo from './img/WazuhPartnersPortal';

const DashboardNavbar = () => {
  return (
    <div className='flex fixed w-full items-center justify-center h-16 px-5 bg-white dark:bg-[#212121] shadow-lg z-10 3xl:max-w-[1400px]'>
      <div className='w-full flex justify-between'>
        <div className='flex items-center'>
          <Link to='/dashboard'>
            <div className="w-48 relative bottom-[2px] sm:w-auto lg:pl-3 dark:[--logo-color:white] [--logo-color:#000]">
              <WazuhPartnersPortalLogo mainfill="var(--logo-color)" className="w-full" />
            </div>
          </Link>
        </div>
        <div className='flex items-center'>
          <div className='hidden lg:block'>
            <MenuProfile />
          </div>
          <div className='lg:hidden'>
            <div className='z-[30]'>
              <MobileMenu />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardNavbar;
